import Bowser from 'bowser';
import { TOLERANCE_LEVEL, detectRangeSettings, BROWSER_FULLY_FUNCTIONAL_RANGE, BROWSER_RECOMMEND_UPGRADE_RANGE } from './constants';
import { isBrave } from './special-detections/checkBrave';
var PLATFORMS_MAP = Bowser.PLATFORMS_MAP;
/**
 * Get the result of browser detection.
 *
 * @param {number} tolerance The tolerance number
 *
 * @returns {boolean} The truthy of the detection.
 */

export var isBrowserSupport = function isBrowserSupport() {
  var tolerance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TOLERANCE_LEVEL.RECOMMEND;
  if (typeof window === 'undefined') return false;
  var browser = Bowser.getParser(window.navigator.userAgent);
  return browser.satisfies(detectRangeSettings[tolerance]);
};
/**
 * @returns {number} 0 || 1 || 2
 *
 * 0: must upgrade browser
 *
 * 1: suggest to upgrade browser
 *
 * 2: no need to upgrade browser
 */

export var browserCompatibility = function browserCompatibility() {
  var browserInfo = Bowser.getParser(window.navigator.userAgent);

  if (browserInfo.satisfies(BROWSER_FULLY_FUNCTIONAL_RANGE)) {
    return 2;
  }

  if (browserInfo.satisfies(BROWSER_RECOMMEND_UPGRADE_RANGE)) {
    return 1;
  }

  return 0;
};
/**
 * Get current browser by user agent
 * @returns {string}
 * ref: https://www.npmjs.com/package/bowser
 */

export var getBrowser = function getBrowser() {
  var _ref = window.navigator || {},
      _ref$userAgent = _ref.userAgent,
      userAgent = _ref$userAgent === void 0 ? {} : _ref$userAgent;

  if (isBrave()) {
    return 'Brave';
  }

  var browser = Bowser.getParser(userAgent);
  return browser.getBrowserName();
};
/**
 * Chect current browser is mobile(h5) or pc(web)
 * @returns {string}
 */

export var getPlatformType = function getPlatformType() {
  var _ref2 = window.navigator || {},
      _ref2$userAgent = _ref2.userAgent,
      userAgent = _ref2$userAgent === void 0 ? {} : _ref2$userAgent;

  var bowser = Bowser.getParser(userAgent);
  var platformType = bowser.getPlatformType(userAgent);
  return [PLATFORMS_MAP.tablet, PLATFORMS_MAP.mobile].includes(platformType) ? 'h5' : 'web';
};
export { TOLERANCE_LEVEL } from './constants';
export default browserCompatibility;